module.exports = __webpack_public_path__ + "media/asset/images/AndoHazama/ITRI_company_top_AndoHazama-8249b6c6b681618c142b5bfd27b26b1e.png";